import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip,
} from "reactstrap";
import AddModal from "views/components/AddModal";
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ProductModal from "models/Product.modal";
import Productenq from "./productenquries/Productenq";

const Product = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }
  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const initialPage = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(
    parseInt(initialPage, 10) || 1
  );
  const [perPage, setPerPage] = useState(20);

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for products
    const dummyProductData = {
      data: [
        {
          id: "1",
          name: "Mathematics Complete Course - Class 10",
          banner: {
            image: "https://via.placeholder.com/150/0000FF/FFFFFF?text=Math10"
          },
          normal_price: "₹2999",
          discounted_price: "₹1999"
        },
        {
          id: "2",
          name: "Physics Masterclass - Class 12",
          banner: {
            image: "https://via.placeholder.com/150/FF0000/FFFFFF?text=Phy12"
          },
          normal_price: "₹3499",
          discounted_price: "₹2499"
        },
        {
          id: "3",
          name: "Chemistry Foundation - Class 11",
          banner: {
            image: "https://via.placeholder.com/150/00FF00/FFFFFF?text=Chem11"
          },
          normal_price: "₹2799",
          discounted_price: "₹1899"
        },
        {
          id: "4",
          name: "JEE Main Preparation Package",
          banner: {
            image: "https://via.placeholder.com/150/FF00FF/FFFFFF?text=JEE"
          },
          normal_price: "₹4999",
          discounted_price: "₹3499"
        },
        {
          id: "5",
          name: "NEET Biology Complete Course",
          banner: {
            image: "https://via.placeholder.com/150/FFFF00/000000?text=NEET"
          },
          normal_price: "₹3999",
          discounted_price: "₹2799"
        },
        {
          id: "6",
          name: "English Grammar & Literature - Class 9",
          banner: {
            image: "https://via.placeholder.com/150/800080/FFFFFF?text=Eng9"
          },
          normal_price: "₹1999",
          discounted_price: "₹1299"
        },
        {
          id: "7",
          name: "Social Studies Complete - Class 8",
          banner: {
            image: "https://via.placeholder.com/150/008080/FFFFFF?text=SS8"
          },
          normal_price: "₹1799",
          discounted_price: "₹1199"
        },
        {
          id: "8",
          name: "Computer Science Fundamentals",
          banner: {
            image: "https://via.placeholder.com/150/FFA500/FFFFFF?text=CS"
          },
          normal_price: "₹2499",
          discounted_price: "₹1699"
        },
        {
          id: "9",
          name: "Accountancy for Commerce Students",
          banner: {
            image: "https://via.placeholder.com/150/4B0082/FFFFFF?text=ACC"
          },
          normal_price: "₹2299",
          discounted_price: "₹1599"
        },
        {
          id: "10",
          name: "Business Studies Complete Package",
          banner: {
            image: "https://via.placeholder.com/150/DC143C/FFFFFF?text=BUS"
          },
          normal_price: "₹2199",
          discounted_price: "₹1499"
        }
      ],
      meta: {
        current_page: 1,
        per_page: 20,
        total_page: 1,
        total: 10
      }
    };
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyProductData);
      setCurrentPage(dummyProductData.meta.current_page);
      setPerPage(dummyProductData.meta.per_page);
    }, 1000);
  };
  const checkApi = async () => {
    // Simulate API check - no longer needed with dummy data
    console.log("API check simulated with dummy data");
  };

  useEffect(() => {
    getListData();
    //checkApi();
  }, [location]);

  const handleDel = async (delId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // Simulate delete operation
        setTimeout(() => {
          setDataList(prevData => ({
            ...prevData,
            data: prevData.data.filter(item => item.id !== delId)
          }));
          Swal.fire("Deleted!", "The product has been deleted.", "success");
        }, 500);
      }
    });
  };
  const [searchQuery, setSearchQuery] = useState("");

  const filteredData = dataList?.data?.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.normal_price?.toString().includes(searchQuery) ||
      item.discounted_price?.toString().includes(searchQuery)
  );
  return (
    <>
      <div className="pt-7 px-4">
        {/* {!isLoading && ( */}
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between ">
                <h3 className="mb-0">All Product</h3>

                <div className="d-flex flex-row">
                  {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                  <Input
                    className="mr-4"
                    type="text"
                    placeholder="Search by Product Name, Normal Price, or Discount Price"
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <Button
                    size="sm"
                    to="/admin/product/addproduct"
                    tag={Link}
                    color="primary"
                    style={{
                      width: "60%",
                      backgroundColor: "#080278",
                      color: "white",
                      border: "none",
                    }}
                  >
                    +Add Product
                  </Button>
                </div>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">SN NO.</th>
                    <th scope="col">Product Name</th>
                    <th scope="col">Image Banner</th>
                    <th scope="col">Price Normal</th>
                    <th scope="col">Discount Price</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                {!isLoading && (
                  <tbody>
                    {filteredData?.length > 0 ? (
                      filteredData.map((item, index) => {
                        return (
                          <tr
                            key={`product${item.id}`}
                            style={{ cursor: "pointer" }}
                          >
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            <td>{item?.name || "-"}</td>
                            <td>
                              {item?.banner?.image ? (
                                <img
                                  src={item?.banner?.image}
                                  height={50}
                                  style={{ borderRadius: "20%" }}
                                  alt="Banner"
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>{item?.normal_price || "-"}</td>
                            <td>{item?.discounted_price || "-"}</td>
                            <td
                              className="mt-1"
                              style={{ display: "flex", flexDirection: "row" }}
                            >
                              <UncontrolledTooltip
                                placement="top"
                                target="editTooltip"
                              >
                                Edit
                              </UncontrolledTooltip>
                              <Link
                                style={{
                                  margin: "0 5px",
                                  fontSize: "15px",
                                  color: "blue",
                                  alignItems: "center",
                                  display: "inline-block",
                                  marginTop: "10px",
                                  borderRadius: "30%",
                                }}
                                id="editTooltip"
                                to={`/admin/product/editproduct/${item.id}`}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </Link>

                              <UncontrolledTooltip
                                placement="top"
                                target="deleteTooltip"
                              >
                                Delete
                              </UncontrolledTooltip>
                              <p
                                style={{
                                  margin: "0 8px",
                                  fontSize: "15px",
                                  color: "red",
                                  marginTop: "10px",
                                  display: "inline-block",
                                  borderRadius: "20%",
                                }}
                                id="deleteTooltip"
                                onClick={() => handleDel(item.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </p>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr style={{ textAlign: "center" }}>
                        <td colSpan="6" style={{ verticalAlign: "middle" }}>
                          No data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}
              </Table>
              <CardFooter className="py-4">
                <TablePagination
                  totalPages={parseInt(
                    dataList?.meta?.total_page ? dataList?.meta?.total_page : 1
                  )}
                  currentPage={currentPage}
                  pageUrl="/admin/product?"
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
        {/* )} */}

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </div>
      <Productenq />
    </>
  );
};

export default Product;
